export default __webpack_public_path__ + "static/media/ptoPR.3436ddfb.svg";